export default __webpack_public_path__ + "static/media/soft18.1fcde57a.jpg";